import { useEffect, useState } from "react";

const links = [
  { label: "Exit Readiness", href: "/#exit-readiness" },
  { label: "Services", href: "/#services" },
  { label: "Built", href: "/#shipped" },
  { label: "Writing", href: "/#insights" },
  { label: "Contact", href: "/#contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-paper/95 backdrop-blur-md border-b border-rule"
          : "bg-paper border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <a href="/#top" data-testid="nav-logo" className="flex items-baseline gap-3 group">
          <span className="serif text-xl md:text-2xl tracking-tight font-medium text-ink">
            Saran Gandhi
          </span>
          <span className="hidden md:inline overline text-slate">
            &amp; Associates
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm text-ink/70 hover:text-ink transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/#contact"
            data-testid="nav-cta-book"
            className="inline-flex items-center gap-2 bg-ink text-paper px-5 py-2.5 text-sm hover:bg-mustard hover:text-ink transition-colors duration-200"
          >
            Book a call
            <span aria-hidden>→</span>
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-9 h-9 flex flex-col items-center justify-center gap-1.5"
        >
          <span className={`block w-5 h-px bg-ink transition-transform ${open ? "translate-y-[3px] rotate-45" : ""}`} />
          <span className={`block w-5 h-px bg-ink transition-transform ${open ? "-translate-y-[3px] -rotate-45" : ""}`} />
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-rule bg-paper" data-testid="nav-mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base text-ink"
                data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="/#contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta-book"
              className="inline-flex items-center justify-center bg-ink text-paper px-5 py-3 text-sm w-fit"
            >
              Book a call →
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
